interface Props {
  children?: React.ReactNode;
  onClick: (e?: any) => void;
  style?: {};
  type?: 'delete';
  active?: boolean;
  disabled?: boolean;
}

export const ClosingButton: React.FC<Props> = ({ children, onClick, style }) => {
  return (
    <div className="btn-wrapper-close" onClick={onClick} style={style}>
      <i className="fa-solid fa-x" />
    </div>
  );
};

export const BackButton: React.FC<Props> = ({ children, onClick, style }) => {
  return (
    <div className="btn-wrapper-back" onClick={onClick} style={style}>
      <i className="fa-solid fa-arrow-left" />
    </div>
  );
};

export const CustomButton: React.FC<Props> = ({
  active,
  type,
  children,
  onClick,
  disabled,
  style,
}) => {
  let btnActive: string | null = '';
  let btnDel: string | null = '';
  let btnDisable: string | null = '';

  if (active) {
    btnActive = 'btn-connect-active';
  }

  if (type === 'delete') {
    btnDel = 'btn-delete';
  }

  if (disabled) {
    btnDisable = 'btn-disable';
  }

  return (
    <div className="btn-wrapper" onClick={onClick}>
      <button
        type="submit"
        style={style}
        className={`btn-custom ${btnActive} ${btnDel} ${btnDisable}`}
      >
        {children}
      </button>
    </div>
  );
};

export const FormButton: React.FC<Props> = ({ active, type, children, onClick, disabled }) => {
  let btnActive: string | null = '';
  let btnDel: string | null = '';
  let btnDisable: string | null = '';

  if (active) {
    btnActive = 'btn-connect-active';
  }

  if (type === 'delete') {
    btnDel = 'btn-delete';
  }

  if (disabled) {
    btnDisable = 'btn-disable';
  }

  return (
    // <div className="btn-wrapper" onClick={onClick}>
    <button type="submit" className={`btn-custom ${btnActive} ${btnDel} ${btnDisable}`}>
      {children}
    </button>
    // </div>
  );
};
